class VehiclePublishController {
  constructor(authService, enums) {
    "ngInject";

    if(!authService.validateUser(false, 'Vehicle', enums.PERMISSION_TYPE.View, true)) { return; }

    this.name = 'vehiclePublish';
  }
}

export default VehiclePublishController;



// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehiclePublish/vehiclePublish.controller.js